export const getEmployeeDisplayName = ({
  fullName,
  lastName,
  preferredName,
}: {
  fullName: string
  lastName: string
  preferredName?: string | null | undefined
}) => {
  return preferredName ? `${preferredName} ${lastName}` : fullName
}

export type DisplayNameStrategy = 'preferredOrFull' | 'full'

const DEFAULT_DISPLAY_NAME_STRATEGY: DisplayNameStrategy = 'preferredOrFull'

export const resolveEmployeeDisplayName = (
  {
    fullName,
    lastName,
    preferredName,
  }: { fullName: string; lastName: string; preferredName?: string | null | undefined },
  strategy: DisplayNameStrategy = DEFAULT_DISPLAY_NAME_STRATEGY
) => {
  if (strategy === 'full') return fullName
  return getEmployeeDisplayName({ fullName, lastName, preferredName })
}
